import React, { useState, useEffect, useReducer, useRef } from 'react';
import {
  getBusMattersOfBillPageList, businessMattersFieldMappingList, commonConvertGetJsonAllPath,
  ruleConfigDtlDetails, ruleConfigDtlCheckData, ruleConfigDtlSave, ruleConfigDtlAttrConverDelete,
  ruleConfigDtlAttrConverBatDel
} from '@/services/integrationConfig'
import {
  Form,
  Button,
  Select,
  Divider,
  Row,
  Col,
  Input,
  DatePicker,
  Modal,
  Space,
  Table,
  Popconfirm,
  message,
  Tooltip,
} from 'antd';
// import { ruledDetailedFn } from '@/pages/receiptRulesManagement/components/ruledDetailed';
import OtherRules from './otherRules'; //其他子规则
import CalculateFormula from './calculateFormula'; //表达式
import dayjs from 'dayjs';
import styles from './index.module.less';
const TextArea = Input.TextArea;
import { cloneDeep, isNil } from 'lodash';
import { modalExpressRunFn } from '../../expressionManage/components/expressRun';

interface CollectionCreateFormProps {
  onFromSubmit: (type: any, values: any) => void;
  onCancelSubRule: (laodRule?: boolean) => void;
  listRef?: any;
  props: any;
}
/**
 * moment类型转日期
 * @param  momentVal moment类型的日期 默认格式 年-月-日
 */
const momentToDate = (momentVal: any, format = 'YYYY-MM-DD') => {
  // if (!moment.isMoment(momentVal)) return;
  return momentVal ? dayjs(momentVal).format(format) : null;
};

/**
 * 日期转moment类型
 * @param dateVal 字符串的日期 默认格式 年-月-日
 *      headers: { 'Content-Type': 'application/json' },
 */
const dateToMoment = (dateVal: string, format = 'YYYY-MM-DD') => {
  return dateVal ? dayjs(dateVal, format) : null;
};

const SubRulesForm: React.FC<CollectionCreateFormProps> = ({ onFromSubmit, onCancelSubRule, listRef, props }) => {
  console.log(props, 'tyty')
  const { visible, businessMattersData, ruleForm, type, currentItem } = props;
  const [form] = Form.useForm();
  const [addOrEditFooterLoading, setAddOrEditFooterLoading] = useState(false);
  const [openData, setOpenData] = useState(false);
  const [ruleConfigDtlAttrConverList, setRuleConfigDtlAttrConverList]: any = useState([]); //子规则(业财字段值转换)
  const [busMattersOfBillList, setBusMattersOfBillList]: any = useState([]); //账套信息
  const [billAndMappingInfo, setBillAndMappingInfo]: any = useState([]); //财务信息
  const [billFormulaList, setBillFormulaList]: any = useState([]); //账套表达式
  const [subRules, setSubRules]: any = useState({}); //其他子规则
  const textAreaRef = useRef(null);

  const [calclateFormulaDetails, setCalclateFormulaDetails] = useState({}); //表达式
  //账套信息
  const getBusMattersOfBillList = async () => {
    const resuleData = await getBusMattersOfBillPageList({ busMattersId: ruleForm?.businessMattersId })
      .then((res: any) => {
        return res || {};
      })
      .catch((err: any) => {
        return { err };
      });
    setBusMattersOfBillList(resuleData || []);
  };
  //财务信息
  const queryBillAndMappingInfo = async (id: string | number) => {
    const resuleData = await businessMattersFieldMappingList({ busOfBillId: id }).then((res: any) => {
      console.log(res);
      return res || {};
    })
      .catch((err: any) => {
        return { err };
      });
    console.log(resuleData);

    const list = (resuleData || []).map((item: any) => {
      return {
        ...item,
        financeDimensionField: item.financeField,
      };
    });
    setBillAndMappingInfo(list);
  };
  //账套表达式Json
  const getJsonAllPath = async () => {
    const resuleData = await commonConvertGetJsonAllPath(JSON.parse(businessMattersData?.businessParamJson))
      .then((res: any) => {
        return res || {};
      })
      .catch((err: any) => {
        return { err };
      });
    const { paths } = resuleData;
    setBillFormulaList(paths);
  };
  useEffect(() => {
    onReset();
    setRuleConfigDtlAttrConverList([]);
    if (visible) {
      //账套信息
      getBusMattersOfBillList();
      // queryBillAndMappingInfo();
      getJsonAllPath();

      console.log(currentItem);
      if (!isNil(currentItem) && !isNil(currentItem?.id)) {
        // getSubRuleDetails(currentItem);
        getSubRuleDetails(currentItem?.id);
      } else {
        form.setFieldsValue({
          status: true,
          // enableTime: dateToMoment(moment().format('YYYY-MM-DD'), 'YYYY-MM-DD HH:mm:ss'),
          // stopTime: dateToMoment('2099-01-01 00:00:00', 'YYYY-MM-DD HH:mm:ss'),
        });
      }
    }
  }, [visible]);

  //子规则详情
  const getSubRuleDetails = (id: any) => {
    ruleConfigDtlDetails(id).then((resp: any) => {
      const { enableTime, stopTime, quoteRuleDtlId, ruleConfigDtlAttrConverList } = resp;
      console.log(enableTime, 'rrrr')
      form.setFieldsValue({
        ...resp,
        enableTime: dateToMoment(dayjs(enableTime).format('YYYY-MM-DD HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss'),
        stopTime: dateToMoment(dayjs(stopTime).format('YYYY-MM-DD HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss'),
      });

      setSubRules({
        quoteRuleDtlId: quoteRuleDtlId,
      });

      if (isValidArray(ruleConfigDtlAttrConverList)) {
        const tempList = ruleConfigDtlAttrConverList.map((item: any, index: number) => {
          return {
            ...item,
            sortIndex: index + 1,
          };
        });
        setRuleConfigDtlAttrConverList(tempList);
      }
    });
  };

  // 重置
  const onReset = () => {
    form.resetFields();
  };

  const look = (obj = {}) => {
    // ruledDetailedFn({
    //   fn: () => {},
    //   ...obj,
    // });
  };
  //重置数据
  const reaseData = () => {
    form.setFieldsValue({
      quoteRuleDtlId: null,
      quoteRuleDtlName: null,
      calculateFormula: null,
    });
    //业财字段值转换
    setRuleConfigDtlAttrConverList([]);
    // 批量删除
    batchDelSubRuleDetailsConverList([]);
  };
  // 提交
  const onSaveSubRule = () => {
    //规则表单
    // const ruleFormField: any = ruleForm.getFieldsValue();
    const formField = form.validateFields(); //触发表单验证
    formField.then((res) => {
      res.businessMattersId = ruleForm?.businessMattersId; //业务事项id
      res.businessMatters = ruleForm?.businessMatters; //业务事项
      res.ruleConfigId = ruleForm?.id; //主规则id
      res.enableTime = momentToDate(res.enableTime, 'YYYY-MM-DD HH:mm:ss');
      res.stopTime = momentToDate(res.stopTime, 'YYYY-MM-DD HH:mm:ss');

      let list = ruleConfigDtlAttrConverList || []; //业财字段值转换

      // const isPass = (list || []).every((item: any, index: number) => {
      //   let isFlag = false;
      //   if (isNil(item.billId)) {
      //     message.warning(`第${index + 1}行业财字段值转换,请选择账套!`);
      //     isFlag = false;
      //     }
      //      else if (isNil(item.calculateFormula) || item?.calculateFormula?.trim() === '') {
      //       message.warning(`第${index + 1}行业财字段值转换,请输入表达式!`);
      //       isFlag = false;
      //   } else {
      //     isFlag = true;
      //   }
      //   return isFlag;
      // });
      // if (!isPass) return;

      const { id } = res;
      list = list.map((item: any) => {
        return {
          ...item,
          ruleConfigId: ruleForm.id, //主规则id
          ruleConfigDtlId: res?.id, //子规则id
        };
      });

      res.ruleConfigDtlAttrConverList = list;
      console.log(res);
      //编辑子规则
      if (res?.id) {
        // 校验子规则是否被引用
        ruleConfigDtlCheckData(res?.id).then((resp: any) => {
          if (resp.message) {
            // 保存子规则
            setAddOrEditFooterLoading(true);
            ruleConfigDtlSave({ ...res, ...(id && { id }) })
              .then((resp: any) => {
                message.success(resp?.message || '操作成功')
                setAddOrEditFooterLoading(false);
                listRef?.current?.reload();
                onCancelSubRule(true);
              })
              .catch((err: any) => { })
              .finally(() => {
                setAddOrEditFooterLoading(false);
              });
          } else {
            Modal.confirm({
              title: '提示!',
              content: resp,
              onOk: () => {
                return new Promise((resolve, reject) => {
                  // 保存子规则
                  setAddOrEditFooterLoading(true);
                  ruleConfigDtlSave({ ...res, ...(id && { id }) }).then((resp: any) => {
                    message.success(resp?.message || '操作成功')
                    setAddOrEditFooterLoading(false);
                    listRef?.current?.reload();
                    onCancelSubRule(true);
                    resolve(res.data);
                  })
                    .catch((err: any) => {
                      reject(err);
                    })
                    .finally(() => {
                      setAddOrEditFooterLoading(false);
                    });
                });
              },
            });
          }
        })
          .finally(() => { });
      } else {
        // 保存子规则
        setAddOrEditFooterLoading(true);
        ruleConfigDtlSave({ ...res, ...(id && { id }) })
          .then((resp: any) => {
            message.success(resp?.message || '操作成功')
            setAddOrEditFooterLoading(false);
            listRef?.current?.reload();
            onCancelSubRule(true);
          })
          .finally(() => {
            setAddOrEditFooterLoading(false);
          });
      }
    });
  };

  /**
   * 是否为有效的数组
   * @param arr 数组
   */
  const isValidArray = (arr: any[]) => {
    return arr && Array.isArray(arr) && arr.length > 0 ? true : false;
  };

  /**
   * 渲染Select组件的下拉项Option
   * @param list 数组 or map={A:'学生',B:'老师'}
   * @param _key 指定的option Key 默认当前list的key
   * @param _value 指定的option Value  默认当前list的value
   */
  const renderSelectOpt = (list: any[], _key: string, _value: string) => {
    // 数组类型
    if (Array.isArray(list)) {
      return (list || []).map((item, index) => (
        <Select.Option key={index} value={item[_key] || item.key} dataitem={item}>
          {item[_value] || item.value}
        </Select.Option>
      ));
    }
    //map类型
    if (typeof list === 'object' && list !== null) {
      return Object.keys(list).map((item, index) => (
        <Select.Option value={item} key={index} dataitem={item}>
          {list[item]}
        </Select.Option>
      ));
    }
  };
  const disabledStopDate = (current: any) => {
    //启用时间后一天
    // const enableTime = moment(form.getFieldValue('enableTime')).add('1', 'days');

    const { ruleEnableTime, ruleStopTime } = ruleForm;
    const enableTime = form.getFieldValue('enableTime');
    return (
      (current && current < enableTime) ||
      (current && current < ruleEnableTime) ||
      (current && current > dayjs(ruleStopTime).add(1, 'days'))
    );
  };
  const disabledEnableTime = (current: any) => {
    const { ruleEnableTime, ruleStopTime } = ruleForm;
    const stopTime = form.getFieldValue('stopTime');
    return (
      (current && current > stopTime) ||
      (current && current < ruleEnableTime) ||
      (current && current > dayjs(ruleStopTime).add(1, 'days'))
    );
  };

  const _onConfirmDelAttrConverHnadle = (index: number) => {
    const list = cloneDeep(ruleConfigDtlAttrConverList);
    list.splice(index, 1);
    const nullArr: any = [];
    let newList = list.concat(nullArr);
    newList = (newList || []).map((item: any, ind: number) => {
      return {
        ...item,
        sortIndex: ind + 1,
      };
    });
    setRuleConfigDtlAttrConverList(newList);
  };
  const _onConfirmDelAttrConver = (record: any, index: number) => {
    console.log(record);
    if (record?.id) {
      ruleConfigDtlAttrConverDelete(record?.id).then((resp: any) => {
        // message.info(resp?.data?.message);
        _onConfirmDelAttrConverHnadle(index);
      })
        .finally(() => { });
    }
  };

  const _onConfirmDel = (record: any, index: number) => {
    if (record?.type == 'add') {
      _onConfirmDelAttrConverHnadle(index);
    } else {
      _onConfirmDelAttrConver(record, index);
    }
  };

  const changeBilName = (index: number, val: any, opt: any) => {
    setBillAndMappingInfo([]); //清空财务字段list
    const tempList: any = cloneDeep(ruleConfigDtlAttrConverList);
    tempList[index].billId = opt?.dataitem?.billId;
    tempList[index].bilName = opt?.children;
    setRuleConfigDtlAttrConverList(tempList);
    queryBillAndMappingInfo(opt?.dataitem?.id);
  };
  const changeFinanceDimensionField = (index: number, val: any, opt: any) => {
    const tempList: any = cloneDeep(ruleConfigDtlAttrConverList);
    tempList[index].financeDimensionField = val;
    tempList[index].financeFieldDesc = opt?.dataitem?.financeFieldDesc;
    setRuleConfigDtlAttrConverList(tempList);
  };
  const focusFinanceDimensionField = (index: number) => {
    console.log(index);
    if (type === 'edit') {
      const tempList: any = cloneDeep(ruleConfigDtlAttrConverList);
      //账套list
      const billList: any = cloneDeep(busMattersOfBillList);
      const billId = tempList[index].billId;
      const primaryId = billList.find((item: any) => item.billId === billId).id;
      console.log(primaryId);
      if (!isNil(primaryId)) {
        queryBillAndMappingInfo(primaryId);
      }
    }
  };

  // -----------------------表达式------------------------
  const calculateFormulaEdit = (type: string, index: number, record: any) => {
    setCalclateFormulaDetails({
      ...calclateFormulaDetails,
      currentDatails: record,
      calculateFormulaData: { billFormulaList: billFormulaList, busMattersOfBillList: busMattersOfBillList },
      visible: true,
      type,
      index,
    });
  };

  const rowEdit = (i: number) => {
    const list = cloneDeep(ruleConfigDtlAttrConverList);
    list[i].type = 'edit';
    setRuleConfigDtlAttrConverList(list);
  };

  const onFromSubmitCalc = (values: any) => {
    console.log(values);
    const { index } = values;
    const list = cloneDeep(ruleConfigDtlAttrConverList);
    list[index].calculateFormula = values?.calculateFormula;
    list[index].calculateFormulaName = values?.calculateFormulaName;
    list[index].calculateFormulaId = values?.calculateFormulaId;
    setRuleConfigDtlAttrConverList(list);
    onCancelCalc();
  };
  const onCancelCalc = () => {
    setCalclateFormulaDetails({
      ...calclateFormulaDetails,
      calculateFormulaData: { billFormulaList: [], busMattersOfBillList: [] },
      visible: false,
    });
  };

  const formItemLayout = {
    labelCol: { span: 9 },
    wrapperCol: { span: 16 },
  };
  const formItemLayout2 = {
    labelCol: { span: 3 },
    wrapperCol: { span: 21 },
  };
  const formItemLayout3 = {
    labelCol: { span: 0 },
    wrapperCol: { span: 24 },
  };
  const statusList = [
    { key: true, value: '启用' },
    { key: false, value: '禁用' },
  ];
  const operateBar = {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '10px 0',
  };
  const editBar: any = {
    border: '1px solid #e6e6e6',
    borderRadius: '10px',
    minHeight: '160px',
    width: '100%',
    padding: '4px 4px',
  };
  const checkBox: any = {
    color: '#1890ff',
    border: '1px solid #1890ff',
    padding: '2px 6px',
    marginLeft: '4px',
    borderRadius: '5px',
    marginBottom: '6px',
    cursor: 'pointer',
    display: 'inline-block',
  };
  const checkBoxDisabled: any = {
    color: '#f5f5f5',
    border: '1px solid #f5f5f5',
    padding: '2px 6px',
    marginLeft: '4px',
    borderRadius: '5px',
    marginBottom: '6px',
    cursor: 'not-allowed',
    display: 'inline-block',
    background: '#d9d9d9',
  };
  const checkBox2: any = {
    color: '#faad14',
    border: '1px solid #faad14',
    padding: '2px 6px',
    marginLeft: '4px',
    borderRadius: '5px',
    marginBottom: '6px',
    cursor: 'pointer',
    display: 'inline-block',
  };
  const busMattersOfBillListOpt = renderSelectOpt(busMattersOfBillList, 'billId', 'billName');
  const billAndMappingInfoOpt = renderSelectOpt(billAndMappingInfo, 'financeDimensionField', 'financeDimensionField');

  const columns: any = [
    {
      title: '序号',
      dataIndex: 'sortIndex',
      align: 'center',
      ellipsis: true,
      width: '50px',
    },
    {
      title: '账套ID',
      dataIndex: 'billId',
      align: 'center',
      width: '130px',
      ellipsis: true,
    },
    {
      title: '账套',
      dataIndex: 'billName',
      align: 'center',
      ellipsis: true,
      render: (_text: any, _record: any, _index: any) => {
        return (
          <>
            {['add', 'edit'].includes(_record?.type) && (
              <Select
                size="small"
                style={{ width: '100%' }}
                placeholder={'请选择'}
                defaultValue={_record?.billName}
                onChange={(val, opt) => changeBilName(_index, val, opt)}
              >
                {busMattersOfBillListOpt}
              </Select>
            )}
            {!['add', 'edit'].includes(_record?.type) && <span>{_text}</span>}
          </>
        );
      },
    },
    {
      title: '财务字段',
      dataIndex: 'financeDimensionField',
      align: 'center',
      ellipsis: true,
      width: '180px',
      render: (_text: any, _record: any, _index: any) => {
        return (
          <>
            {['add', 'edit'].includes(_record?.type) && (
              <Select
                size="small"
                style={{ width: '100%' }}
                placeholder={'请选择'}
                showSearch
                defaultValue={_record?.financeDimensionField}
                onChange={(val, opt) => changeFinanceDimensionField(_index, val, opt)}
                onFocus={() => focusFinanceDimensionField(_index)}
              >
                {billAndMappingInfoOpt}
              </Select>
            )}
            {!['add', 'edit'].includes(_record?.type) && (
              <span>
                <Tooltip title={_text}>{_text}</Tooltip>
              </span>
            )}
          </>
        );
      },
    },
    {
      title: '财务描述',
      dataIndex: 'financeFieldDesc',
      align: 'center',
      ellipsis: true,
    },
    {
      title: '引用表达式',
      dataIndex: 'calculateFormulaName',
      align: 'center',
      ellipsis: true,
    },
    {
      title: '表达式',
      dataIndex: 'calculateFormula',
      align: 'center',
      ellipsis: true,
    },
    {
      title: '操作',
      dataIndex: 'action',
      align: 'center',
      width: '182px',
      render: (_text: any, _record: any, _index: any) => {
        return (
          <Space>
            <Button
              size="small"
              type="primary"
              onClick={() => calculateFormulaEdit('add', _index, _record)}
              disabled={btnDisabled(_index) || type == 'view' || !isNil(subRules?.quoteRuleDtlId)}
            >
              表达式
            </Button>
            <Button
              size="small"
              type="primary"
              // onClick={() => calculateFormulaEdit('edit', _index, _record)}
              onClick={() => rowEdit(_index, _record)}
              disabled={btnDisabled(_index) || type == 'view' || !isNil(subRules?.quoteRuleDtlId)}
            >
              编辑
            </Button>
            <Popconfirm
              title={'确定删除该项吗？'}
              okText="是"
              cancelText="否"
              onConfirm={() => _onConfirmDel(_record, _index)}
              disabled={type == 'view'}
            >
              <Button size="small" danger disabled={type == 'view' || !isNil(subRules?.quoteRuleDtlId)}>
                删除
              </Button>
            </Popconfirm>
          </Space>
        );
      },
    },
  ];

  const onOkData = (rows: any) => {
    console.log(rows);
    const obj = rows[0];

    setOpenData(false);
    const tmepObj = cloneDeep(obj);
    delete obj?.id; //删除其他子规则id,避免和子规则id冲突
    delete obj?.name; //删除其他子规则,避免和子规则
    delete obj?.code; //删除其他子规则,避免和子规则

    const tempObj = {
      ...obj,
      quoteRuleDtlId: tmepObj?.id,
      quoteRuleDtlName: tmepObj?.name,
      enableTime: dateToMoment(dayjs(obj?.enableTime).format('YYYY-MM-DD HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss'),
      stopTime: dateToMoment(dayjs(obj?.stopTime).format('YYYY-MM-DD HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss'),
    };
    form.setFieldsValue(tempObj);
    setSubRules(tempObj);
    getSubRuleDetailsConverList(tmepObj?.id);
  };
  //获取业财字段值转换列表
  const getSubRuleDetailsConverList = (id: any) => {
    batchDelSubRuleDetailsConverList();
    ruleConfigDtlDetails(id).then((resp: any) => {
      const { ruleConfigDtlAttrConverList } = resp;
      console.log(resp);
      if (isValidArray(ruleConfigDtlAttrConverList)) {
        const tempList = ruleConfigDtlAttrConverList.map((item: any, index: number) => {
          delete item.id;
          return {
            ...item,
            sortIndex: index + 1,
          };
        });
        setRuleConfigDtlAttrConverList(tempList);
      } else {
        setRuleConfigDtlAttrConverList([]);
      }
    });
  };

  // 批量删除 - 业财字段值转换
  const batchDelSubRuleDetailsConverList = async () => {
    const list = cloneDeep(ruleConfigDtlAttrConverList);
    console.log(list);
    if (isValidArray(list)) {
      //过滤出有id的数据
      const fliterList = list.filter((item: any) => item.id);
      console.log(fliterList);
      const idList = fliterList.map((item: any) => item.id);
      console.log(idList);
      if (!isValidArray(idList)) return;
      ruleConfigDtlAttrConverBatDel(idList).then((resp: any) => { }).finally(() => { });
    }
  };

  const onCancelData = () => {
    setOpenData(false);
  };

  const btnDisabled = (index: number) => {
    const oldData: any = cloneDeep(ruleConfigDtlAttrConverList);
    const { billId, financeDimensionField } = oldData[index];
    let isFlag = false;
    if (isNil(billId) || isNil(financeDimensionField)) {
      isFlag = true;
    }
    return isFlag;
  };

  const addData = () => {
    const oldData: any = cloneDeep(ruleConfigDtlAttrConverList);
    oldData.push({
      sortIndex: oldData.length + 1,
      billId: null,
      bilName: null,
      financeDimensionField: null,
      financeFieldDesc: null,
      calculateFormulaName: null,
      calculateFormula: null,
      type: 'add',
    });
    setRuleConfigDtlAttrConverList(oldData);
  };
  const dateFormat = 'YYYY-MM-DD HH:mm:ss';
  const statusListOpt = renderSelectOpt(statusList, 'key', 'value');

  const getCursorPosition = (ctrl: any) => {
    const CaretPos = {
      start: 0,
      end: 0,
    };
    if (ctrl?.resizableTextArea?.textArea.selectionStart) {
      CaretPos.start = ctrl?.resizableTextArea?.textArea.selectionStart;
    }
    if (ctrl?.resizableTextArea?.textArea.selectionEnd) {
      CaretPos.end = ctrl?.resizableTextArea?.textArea.selectionEnd;
    }
    return CaretPos;
  };

  const setCursorPosition = (ctrl: any, start: any, end: any) => {
    ctrl.focus();
    // ctrl.setSelectionRange(start, end);  // 废弃
    if (ctrl?.resizableTextArea?.textArea.selectionStart) {
      ctrl.resizableTextArea.textArea.selectionStart = start;
    }
    if (ctrl?.resizableTextArea?.textArea.selectionEnd) {
      ctrl.resizableTextArea.textArea.selectionEnd = end;
    }
  };

  const cursorRef = useRef({
    start: 0,
    end: 0,
  });
  const handleRecordCursorPosition = () => {
    const position = getCursorPosition(textAreaRef.current); //获取光标位置
    cursorRef.current = position;
  };

  const handleBlur = () => {
    handleRecordCursorPosition();
  };

  const handleChangeRuleText = (e: any) => {
    // setRuleText(e.target.value);
    handleRecordCursorPosition();
  };

  const timeOutRef: any = useRef();

  // -------

  const chooseField = (v: any) => {
    const { quoteRuleDtlId } = form.getFieldsValue();
    if (type == 'view') return;
    if (!isNil(quoteRuleDtlId)) return;

    let repeatVal = v.replaceAll('.', '．'); //英文字符替换成中文字符
    repeatVal = repeatVal.replaceAll('*', '＊'); //英文字符替换成中文字符
    repeatVal = repeatVal.replaceAll('[', '［'); //英文字符替换成中文字符
    repeatVal = repeatVal.replaceAll(']', '］'); //英文字符替换成中文字符
    const { calculateFormula } = form.getFieldsValue();

    // form.setFieldsValue({
    //   calculateFormula: isNil(calculateFormula) ? `${repeatVal}` : `${calculateFormula}${repeatVal}`,
    // });

    if (calculateFormula?.length) {
      const insertStart = cursorRef.current.start; //插入的位置
      const insertEnd = cursorRef.current.end + calculateFormula.length; //插入结束的位置
      // 截取插入位置前面的数据+选择的数据+截取插入位置前面的数据
      const newText = calculateFormula.slice(0, insertStart) + repeatVal + calculateFormula.slice(insertStart);
      timeOutRef.current = setTimeout(() => {
        setCursorPosition(textAreaRef.current, insertStart, insertEnd);
      }, 200);
      form.setFieldsValue({
        calculateFormula: isNil(newText) ? `${repeatVal}` : `${newText}`,
      });
    } else {
      form.setFieldsValue({
        calculateFormula: `${repeatVal}`,
      });
    }
  };
  // 结果演算
  const onExpress = () => {
    if (form.getFieldValue('calculateFormula')) {
      modalExpressRunFn(form.getFieldValue('calculateFormula'));
    } else {
      message.error('请输入表达式');
      return false;
    }
  };
  const titleObj: any = {
    add: '新增',
    view: '查看',
    edit: '编辑',
  };

  const disabledForm = () => {
    let isFlag = false;
    if (type == 'view') {
      isFlag = true;
    } else {
      isFlag = false;
    }
    return isFlag;
  };
  const disabledResetBtn = () => {
    let isFlag = false;
    const { quoteRuleDtlId } = form.getFieldsValue();
    if (type == 'view') {
      isFlag = true;
    } else if (type !== 'view') {
      //存在引用其他子规则 才可重置
      if (!isNil(quoteRuleDtlId)) {
        isFlag = false;
      } else {
        isFlag = true;
      }
    }

    return isFlag;
  };
  return (
    <div>
      <Modal
        width={1140}
        visible={props?.visible}
        // title={`${props?.details?.id ? '编辑子规则' : '新增子规则'}`}
        title={`${titleObj[type]}子规则`}
        onCancel={onCancelSubRule}
        onOk={onSaveSubRule}
        okButtonProps={{ loading: addOrEditFooterLoading, disabled: disabledForm() }}
        footer={[
          <Button onClick={onCancelSubRule}>取消</Button>,
          // <Button type="primary" disabled={type == 'view'} ghost onClick={reaseData}>
          <Button type="primary" disabled={disabledResetBtn()} ghost onClick={reaseData}>
            重置
          </Button>,
          <Button type="primary" disabled={type == 'view'} onClick={onSaveSubRule}>
            确定
          </Button>,
        ]}
      >
        <Form form={form} {...formItemLayout}>
          <Row>
            <Col span={8}>
              <Form.Item label="子规则id" name="id" rules={[{ required: false }]} noStyle hidden>
                <Input disabled />
              </Form.Item>
              <Form.Item label="子规则编码" name="code" rules={[{ required: false }]}>
                <Input placeholder="自动生成" disabled />
              </Form.Item>
            </Col>
            <Form.Item shouldUpdate noStyle>
              {({ getFieldValue }) => {
                return (
                  <Col span={8}>
                    <Form.Item label="子规则名称" name="name" rules={[{ required: true }]}>
                      <Input placeholder="请输入子规则名称" disabled={disabledForm()} />
                    </Form.Item>
                  </Col>
                );
              }}
            </Form.Item>
            <Form.Item shouldUpdate noStyle>
              {({ getFieldValue }) => {
                return (
                  <Col span={8}>
                    <Form.Item label="状态" name="status" rules={[{ required: true }]}>
                      <Select placeholder="请选择状态" disabled={disabledForm()}>
                        {statusListOpt}
                      </Select>
                    </Form.Item>
                  </Col>
                );
              }}
            </Form.Item>
          </Row>
          <Row>
            <Form.Item shouldUpdate noStyle>
              {({ getFieldValue }) => {
                return (
                  <Col span={8}>
                    <Form.Item label="启用时间" name="enableTime" rules={[{ required: true }]}>
                      <DatePicker
                        style={{ width: '100%' }}
                        format={dateFormat}
                        clearIcon={false}
                        disabled={disabledForm()}
                        onChange={(date: any) => {
                          const temp = momentToDate(date, 'YYYY-MM-DD HH:mm:ss');
                          form.setFieldsValue({
                            enableTime: dateToMoment(`${temp} 00:00:00`, dateFormat),
                          });
                        }}
                        disabledDate={disabledEnableTime}
                        placeholder="主规则启停时间范围内"
                      />
                    </Form.Item>
                  </Col>
                );
              }}
            </Form.Item>
            <Form.Item shouldUpdate noStyle>
              {({ getFieldValue }) => {
                return (
                  <Col span={8}>
                    <Form.Item label="停用时间" name="stopTime" rules={[{ required: true }]}>
                      <DatePicker
                        style={{ width: '100%' }}
                        format={dateFormat}
                        clearIcon={false}
                        disabled={disabledForm()}
                        onChange={(date: any) => {
                          const temp = momentToDate(date, 'YYYY-MM-DD HH:mm:ss');
                          form.setFieldsValue({
                            stopTime: dateToMoment(`${temp} 00:00:00`, dateFormat),
                          });
                        }}
                        disabledDate={disabledStopDate}
                        placeholder="主规则启停时间范围内"
                      />
                    </Form.Item>
                  </Col>
                );
              }}
            </Form.Item>
            <Col span={8}>
              <Form.Item label="引用其他子规则id" name="quoteRuleDtlId" rules={[{ required: false }]} noStyle hidden>
                <Input disabled />
              </Form.Item>
              <Form.Item label="引用其他子规则" name="quoteRuleDtlName" rules={[{ required: false }]}>
                <Input.Search
                  readOnly
                  disabled={disabledForm()}
                  placeholder={'请选择其他子规则'}
                  enterButton="请选择"
                  onSearch={() => setOpenData(true)}
                  className={styles.disabledInput}
                />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item shouldUpdate noStyle>
            {({ getFieldValue }) => {
              return (
                <Col span={24}>
                  <Form.Item
                    label="备注"
                    name="remark"
                    {...formItemLayout2}
                    rules={[{ required: false, message: '请选输入备注' }]}
                  >
                    <TextArea rows={3} autoSize={false} disabled={disabledForm()} maxLength={600} />
                  </Form.Item>
                </Col>
              );
            }}
          </Form.Item>

          <Divider style={{ margin: '0 0 8px 0' }} />
          <div>
            <div style={operateBar}>
              <span>确定账套的表达式</span>
              <Space>
                <Button type="primary" size="small" disabled={disabledForm()} onClick={onExpress}>
                  结果演算
                </Button>
              </Space>
            </div>
            <Form.Item shouldUpdate noStyle>
              {({ getFieldValue }) => {
                return (
                  <div style={editBar}>
                    {(billFormulaList || []).map((item: any, i: number) => {
                      return (
                        <span
                          style={
                            type == 'view' || !isNil(getFieldValue('quoteRuleDtlId')) ? checkBoxDisabled : checkBox
                          }
                          onClick={() => chooseField(item)}
                          className={styles.item}
                          key={`item${i}`}
                        >
                          {item}
                        </span>
                      );
                    })}
                    {(busMattersOfBillList || []).map((item: any) => {
                      return (
                        <span
                          style={
                            type == 'view' || !isNil(getFieldValue('quoteRuleDtlId')) ? checkBoxDisabled : checkBox2
                          }
                          onClick={() => chooseField(item?.billId)}
                          className={styles.item}
                          key={item?.billId}
                        >
                          {`${item?.billName}#${item?.billId}`}
                        </span>
                      );
                    })}
                    <div>
                      <Form.Item
                        name="calculateFormula"
                        rules={[{ required: true, message: '请选输入表达式' }]}
                        {...formItemLayout3}
                      >
                        <TextArea
                          ref={textAreaRef}
                          onChange={handleChangeRuleText}
                          onBlur={handleBlur}
                          autoSize={{ minRows: 3, maxRows: 4 }}
                          disabled={disabledForm() || !isNil(getFieldValue('quoteRuleDtlId'))}
                          style={{ width: '100%' }}
                        />
                      </Form.Item>
                    </div>
                  </div>
                );
              }}
            </Form.Item>
          </div>

          <div>
            <Form.Item shouldUpdate noStyle>
              {({ getFieldValue }) => {
                return (
                  <div style={operateBar}>
                    <span>业财字段值转换</span>
                    <Space>
                      <Button
                        type="primary"
                        size="small"
                        onClick={addData}
                        // disabled={disabledForm()}
                        disabled={disabledForm() || !isNil(getFieldValue('quoteRuleDtlId'))}
                      >
                        新增行
                      </Button>
                    </Space>
                  </div>
                );
              }}
            </Form.Item>
            <Table
              columns={columns}
              dataSource={ruleConfigDtlAttrConverList || []}
              rowKey={'sortIndex'}
              size="small"
              bordered
            />
          </div>
        </Form>
      </Modal>
      {/*  其他子规则*/}
      <OtherRules
        open={openData}
        config={form}
        type={'radio'}
        showMode="drawer"
        title={'规则列表'}
        width={960}
        onOk={onOkData}
        onCancel={onCancelData}
      />
      <CalculateFormula props={calclateFormulaDetails} onFromSubmit={onFromSubmitCalc} onCancel={onCancelCalc} />
    </div>
  );
};

export default SubRulesForm;
